module.exports = __webpack_public_path__ + "img/carolanne-lavoie-pilon.1fc1d6ec.png";